<template>
    <AppForm
        v-if="loaded"
        :loading="loading"
        :is-new="false"
        heading="Settings"
        @submit="submitHandler"
    >
        <template v-slot:tabs>
            <Tabs
                :tabs="tabs"
                :active="activeTab"
                @changed="value => activeTab = value"
            />
        </template>
        <template v-slot:main>

            <div v-show="activeTab === 'start_screen'">
                <FormGroup
                    v-for="locale in locales"
                    :key="`start_screen_text_${locale}`"
                    :flag="locale"
                    :label-for="`start_screen_text_${locale}`"
                    label="Start screen text"
                >
                    <InputField
                        v-model="settings.start_screen_text[locale]"
                        :required="true"
                        :name="`start_screen_text_${locale}`"
                        type="text"
                    />
                </FormGroup>

                <FormGroup
                    label="Start screen image"
                    label-for="start_screen_image"
                >
                    <MediaField
                        :initial-media="settings.start_screen_image"
                        @changed="image => settings.start_screen_image = image"
                    />
                </FormGroup>

                <FormGroup
                    label="Start screen video"
                    label-for="start_screen_video"
                >
                    <MediaField
                        :initial-media="settings.start_screen_video"
                        @changed="video => settings.start_screen_video = video"
                    />
                </FormGroup>
            </div>

            <div v-show="activeTab === 'pages'">
                <FormGroup label="Caravan pages">
                    <img
                        src="../../assets/images/caravan.jpg"
                        class="imageHelper"
                    >
                    <Relationship
                        :active-items="settings.caravan_pages"
                        :max="11"
                        endpoint="/api/pages/all"
                        @addItem="item => settings.caravan_pages.push(item.id)"
                        @removeItem="index => settings.caravan_pages.splice(index, 1)"
                    />
                </FormGroup>

                <FormGroup label="Motorhome pages">
                    <img
                        src="../../assets/images/motorhome.jpg"
                        class="imageHelper"
                    >
                    <Relationship
                        :active-items="settings.motorhome_pages"
                        :max="14"
                        endpoint="/api/pages/all"
                        @addItem="item => settings.motorhome_pages.push(item.id)"
                        @removeItem="index => settings.motorhome_pages.splice(index, 1)"
                    />
                </FormGroup>
            </div>

        </template>
    </AppForm>
</template>

<script>
import FormGroup from '../../components/form/FormGroup.vue';
import InputField from '../../components/form/InputField.vue';
import AppForm from '../../components/form/AppForm.vue';
import MediaField from '../../components/form/MediaField.vue';
import Relationship from '../../components/form/Relationship.vue';
import Tabs from '../../components/ui/Tabs.vue';
import { get, store } from '../../utils/apiHelper';
import { locales } from '../../utils/translate';

export default {
    components: {
        AppForm,
        FormGroup,
        InputField,
        MediaField,
        Relationship,
        Tabs,
    },
    data: () => ({
        loaded: false,
        loading: false,
        settings: {
            start_screen_text: {},
            caravan_pages: [],
            motorhome_pages: [],
        },
        activeTab: 'start_screen',
        tabs: [
            {
                value: 'start_screen',
                label: 'Start screen',
            },
            {
                value: 'pages',
                label: 'Pages',
            },
        ],
        locales,
    }),
    async created() {
        const settings = await get('/api/settings');

        for (let i = 0; i < settings.length; i++) {
            const setting = settings[i];
            this.settings[setting.name] = setting.value;
        }

        this.loaded = true;
    },
    methods: {
        async submitHandler() {
            this.loading = true;
            await store('/api/settings', { data: this.settings });
            this.loading = false;
        },
    },
};
</script>

<style lang="postcss" scoped>
.imageHelper {
    width: 1000px;
    margin-bottom: 20px;
}
</style>
